import React, { useState, useEffect } from 'react'
import { Alert } from '@heroui/react'
import { Shield, X, RefreshCw } from 'lucide-react'

const AdBlockAlert = ({ onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isReloaded, setIsReloaded] = useState(false)

  useEffect(() => {
    // Check for ad-blocker by monitoring window error events
    const handleError = (event) => {
      if (event.message && (
        event.message.includes('ERR_BLOCKED_BY_CLIENT') ||
        event.message.includes('net::ERR_BLOCKED_BY_CLIENT') ||
        (event.message.includes('firebase') && event.message.includes('blocked'))
      )) {
        setIsVisible(true)
      }
    }

    // Listen for unhandled errors and resource loading errors
    window.addEventListener('error', handleError)
    window.addEventListener('unhandledrejection', (event) => {
      if (event.reason && event.reason.toString().includes('ERR_BLOCKED_BY_CLIENT')) {
        setIsVisible(true)
      }
    })

    return () => {
      window.removeEventListener('error', handleError)
      window.removeEventListener('unhandledrejection', handleError)
    }
  }, [isReloaded])

  const handleReload = () => {
    setIsReloaded(true)
    setIsVisible(false)
    window.location.reload()
  }

  const handleDismiss = () => {
    setIsVisible(false)
    if (onDismiss) {
      onDismiss()
    }
  }

  if (!isVisible || isReloaded) {
    return null
  }

  return (
    <div className="mb-4 mx-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3">
          <Shield className="w-5 h-5 text-yellow-600 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-yellow-800 mb-2">
              ⚠️ Conexión Bloqueada
            </h3>
            <div className="space-y-2 text-sm text-yellow-700">
              <p>
                Tu ad-blocker o extensión de privacidad está bloqueando Firebase, lo que puede causar que algunas funciones no funcionen correctamente (como crear grupos o eventos).
              </p>
              <div className="bg-yellow-100 p-3 rounded-lg">
                <p className="font-medium mb-1">Soluciones:</p>
                <ul className="space-y-1">
                  <li>• Desactiva temporalmente tu ad-blocker para este sitio</li>
                  <li>• Añade <code className="bg-yellow-200 px-1 rounded">*.googleapis.com</code> y <code className="bg-yellow-200 px-1 rounded">firebaseio.com</code> a tu lista blanca</li>
                  <li>• Usa el navegador en modo incógnito</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-2 ml-4">
          <button
            onClick={handleReload}
            className="p-1 rounded hover:bg-yellow-200 transition-colors"
            title="Recargar página"
          >
            <RefreshCw className="w-4 h-4 text-yellow-600" />
          </button>
          <button
            onClick={handleDismiss}
            className="p-1 rounded hover:bg-yellow-200 transition-colors"
            title="Cerrar alerta"
          >
            <X className="w-4 h-4 text-yellow-600" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdBlockAlert